exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "g.mg-x-axis text, g.mg-y-axis text {\n    fill: white;\n    stroke: none;\n    opacity: 1;\n    font-size: 14px;\n}\n\npath.mg-main-line {\n    stroke-width: 2;\n}\n\ng.mg-x-axis line {\n    stroke: white;\n    fill: none;\n    stroke-width: 1;\n}\n\ng.mg-active-datapoint-container text {\n    fill: white;\n    font-size: 11px;\n    opacity: 1;\n}\n\n.mg-line-rollover-circle {\n    fill: #7bf063;\n    stroke: none;\n    r: 7;\n    opacity: 0;\n}\n\n.mg-histogram .mg-bar rect {\n    fill: #fff;\n    width: 14px;\n}\n\n.mg-histogram {\n    transform: translate(-7px);\n}\n", ""]);

// exports
